export default function CircleCropIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" id="Capa_1" viewBox="0 0 700 700">
        <path d="M350,593c-64.91,0-125.93-25.28-171.83-71.17-45.9-45.9-71.17-106.92-71.17-171.83s25.28-125.93,71.17-171.83c45.9-45.9,106.92-71.17,171.83-71.17s125.93,25.28,171.83,71.17c45.9,45.9,71.17,106.92,71.17,171.83s-25.28,125.93-71.17,171.83c-45.9,45.9-106.92,71.17-171.83,71.17ZM350,154.79c-107.64,0-195.21,87.57-195.21,195.21s87.57,195.21,195.21,195.21,195.21-87.57,195.21-195.21-87.57-195.21-195.21-195.21Z"/>
      </svg>
    </>
  );
}
